<template>
  <div class="app-container">
    <list ref="list">
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{row}">
            <el-button type="text" @click="details(row)">查看</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/mall/worder/refund/list";
import editDialog from "@/components/mall/worder/refund/editDialog";

export default {
  name: "worder_refund",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  methods: {
    details(row) {
      this.$refs.editDialog.openEdit(row);
    },
  },
};
</script>